import React from 'react';
import { Send, Inbox } from 'lucide-react';
import { RadioGroup, RadioGroupItem } from './ui/radio-group';

export const tiktokConfig = (mode, privacy) => ({
  tiktok: { consent: { publishMode: mode, ...(mode === 'DIRECT_POST' ? { privacyLevel: privacy } : {}) } },
});

export const TikTokPublishOptions = ({ mode, onModeChange, privacy, onPrivacyChange, disabled = false, prefix }) => (
  <fieldset disabled={disabled} data-testid={`${prefix}-tiktok-options`} className="space-y-3 min-w-0">
    <legend className="text-white/80 text-sm font-medium mb-2">TikTok delivery</legend>
    <RadioGroup value={mode} onValueChange={onModeChange} disabled={disabled}
      aria-label="TikTok delivery mode" data-testid={`${prefix}-tiktok-mode`} className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      {[['DIRECT_POST', 'Publish directly', Send], ['MEDIA_UPLOAD', 'Send to TikTok drafts', Inbox]].map(([value, label, Icon]) => (
        <label key={value} htmlFor={`${prefix}-tiktok-${value}`} className={`flex items-center gap-2 rounded-lg border p-3 text-sm cursor-pointer transition-colors ${mode === value ? 'border-emerald-500/60 bg-emerald-500/10 text-emerald-300' : 'border-white/10 text-white/70 hover:bg-white/5'}`}>
          <RadioGroupItem id={`${prefix}-tiktok-${value}`} value={value} data-testid={`${prefix}-tiktok-${value.toLowerCase()}`} className="border-white/40 text-emerald-400 shrink-0" />
          <Icon size={16} className="shrink-0" /><span>{label}</span>
        </label>
      ))}
    </RadioGroup>
    {mode === 'DIRECT_POST' ? (
      <div>
        <label htmlFor={`${prefix}-tiktok-privacy`} className="text-white/60 text-xs block mb-1">TikTok visibility</label>
        <select id={`${prefix}-tiktok-privacy`} data-testid={`${prefix}-tiktok-privacy`} value={privacy}
          onChange={e => onPrivacyChange(e.target.value)} disabled={disabled}
          className="w-full min-w-0 rounded-lg border border-white/10 bg-[#141414] p-2.5 text-sm text-white focus:border-emerald-500 focus:outline-none">
          <option value="">Select visibility</option>
          <option value="PUBLIC_TO_EVERYONE">Everyone</option>
          <option value="MUTUAL_FOLLOW_FRIENDS">Friends</option>
          <option value="FOLLOWER_OF_CREATOR">Followers</option>
          <option value="SELF_ONLY">Only me</option>
        </select>
      </div>
    ) : (
      <p data-testid={`${prefix}-tiktok-draft-notice`} className="text-amber-200/80 text-xs">Finish editing and publishing in TikTok. Other platforms publish normally.</p>
    )}
  </fieldset>
);